import React, { useState } from 'react';
import Recaptcha from 'react-google-recaptcha';
import { useSelector } from 'react-redux';

export const useRecaptcha = () => {
  const [captcha, setCaptcha] = useState('');

  const config = useSelector(state => state.app.config);

  const Component = (
    <Recaptcha
      key={1}
      sitekey={config.recaptcha.publicKey}
      onChange={(val) => setCaptcha(val)}
    />
  );

  return [captcha, Component];
};

export default { useRecaptcha };
